// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountGroup } from './account-group';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountClass extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  accountClassId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  displayOrder!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountGroups!: AccountGroup[];
}

